module.exports = __webpack_public_path__ + "img/marketing.e60a00c7.jpg";